import { FormQuestionDto, QuestionComponentType } from "@green0meter/api-client";
import React, { FC } from "react";

import NumberInput from "../NumberInput";
import Select from "../Select";
import ShortText from "../ShortText";
import DatePicker from "../DatePicker";
import Email from "../Email";

import { Grid } from "@components/base";
import { useDraftReturn } from "@hooks/useDraftField";

interface MultiInput {
  question: FormQuestionDto;
  disabled?: boolean;
  draftField?: useDraftReturn | null;
}

const MultiInput: FC<MultiInput> = ({ question, disabled, draftField }) => (
  <Grid container spacing={2}>
    {question.childQuestions?.map((childQuestion) => (
      <Grid
        size={{ md: 12 / (question.childQuestions?.length || 2), xs: 12 }}
        key={childQuestion.questionId}
      >
        {childQuestion.componentType === QuestionComponentType.Number && (
          <NumberInput
            question={childQuestion}
            disabled={disabled}
            draftField={draftField}
            parentQuestionCode={question.code}
          />
        )}
        {childQuestion.componentType === QuestionComponentType.ShortText && (
          <ShortText
            question={childQuestion}
            disabled={disabled}
            draftField={draftField}
            parentQuestionCode={question.code}
          />
        )}
        {childQuestion.componentType === QuestionComponentType.DatePicker && (
          <DatePicker
            question={childQuestion}
            disabled={disabled}
            parentQuestionCode={question.code}
          />
        )}
        {childQuestion.componentType === QuestionComponentType.Email && (
          <Email
            question={childQuestion}
            disabled={disabled}
            draftField={draftField}
            parentQuestionCode={question.code}
          />
        )}
        {childQuestion.componentType === QuestionComponentType.Select && (
          <Select
            question={childQuestion}
            disabled={disabled}
            parentQuestionCode={question.code}
          />
        )}
      </Grid>
    ))}
  </Grid>
);

export default MultiInput;
